<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t("lang.requests_for_estimates") }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('quote_requests.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openQuoteRequestForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetQuoteRequests(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.status_id"
                                            :placeholder="$t('lang.status_id')"
                                            :items="quote_request_status"
                                            item-value="option_id"
                                            item-text="option"
                                            prepend-icon="monitor_heart"
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="quote_requests" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openQuoteRequestForm(props.item)">
                                <td>{{ props.item.quote_request_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.request_date }}</td>
                                <td>{{ props.item.reference_number }}</td>
                                <td class="text-center">
                                    <v-chip disabled round text-color="white" class="fs-14 text-center" :color="props.item.status_class">
                                        <span style="min-width: 60px">{{ props.item.status }}</span>
                                    </v-chip>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="quote_requests"></bc-pagination>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openQuoteRequestForm" },
                { title: this.$t("lang.refresh"), action: "dbGetQuoteRequests", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.quote_request_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.company"), sortable: false, width: "50%" },
                { text: this.$t("lang.request_date"), sortable: false, width: "15%" },
                { text: this.$t("lang.reference_number"), sortable: false, width: "15%" },
                { text: this.$t("lang.status_id"), sortable: false, align: "center", width: "8%" },
            ],
            customers: null,
            quote_request: {},
            filter: {
                search: "",
                company_id: "",
                status_id: "",
            },
            dbGetQuoteRequests: _.debounce(this.refresh, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchQuoteRequests", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.quote_requests) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchQuoteRequests({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.quote_requests) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.refresh();
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetQuoteRequests");
        this.$store.commit("resetOptions");
        next();
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.quote_requests.quote_requests_filter,
            page: (state) => state.quote_requests.page,
            rules_quote_requests: (state) => state.quote_requests.rules_quote_requests,
            quote_request_status: (state) => state.options_categories.quote_request_status,
            quote_requests: (state) => state.quote_requests.quote_requests,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchQuoteRequests", "saveQuoteRequest", "deleteQuoteRequest", "fetchOptions"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openQuoteRequestForm(item = null) {
            if (item != null) {
                this.$router.push({ name: "quote_request", params: { id: item.quote_request_id } });
            } else {
                this.$router.push({ name: "quote_request" });
            }
        },
        saveQuoteRequests() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_quote_request")) {
                    let body = this.prepForm(this.quote_request, this.rules_quote_requests);

                    this.saveQuoteRequest({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.$router.push({ name: "quote_request", params: { id: data.quote_request_id } });
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (this.quote_request_status == 0 || force == true) await this.fetchOptions({ body: { slug: "quote_request_status", options: 1 } });

            if (force == true) {
                this.fetchQuoteRequests({
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                    .then((data) => {
                        if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    })
                    .finally(() => {
                        this.quote_request_dialog = false;
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(force);
                    });
            }

            this.finishLoader();
        },
    },
};
</script>
